import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-low-right q-gutter-xs" }
const _hoisted_2 = {
  key: 0,
  class: "app-lows"
}
const _hoisted_3 = {
  key: 1,
  class: "app-lows"
}
const _hoisted_4 = { class: "low-prtr" }
const _hoisted_5 = {
  key: 2,
  class: "app-lows"
}
const _hoisted_6 = { class: "low-safety" }
const _hoisted_7 = {
  key: 3,
  class: "app-lows flex items-center justify-center",
  style: {"width":"60%","margin":"0px"}
}
const _hoisted_8 = {
  key: 4,
  class: "app-lows"
}

interface Props {
  // 分類グループコード
  classificationCode: string;
  // 毒物/劇物名
  regName: string;
  // 化管法
  prtrName: string;
  // 安衛法
  ishlName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplyLowLabel',
  props: {
    classificationCode: {},
    regName: {},
    prtrName: {},
    ishlName: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.classificationCode === '2' || props.classificationCode === '3')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", {
            class: _normalizeClass(props.classificationCode === '2' ? 'low-poison' : 'low-deleterious')
          }, _toDisplayString(props.regName), 3)
        ]))
      : _createCommentVNode("", true),
    (
        props.classificationCode === '5' ||
        props.classificationCode === '6' ||
        (props.prtrName !== null && props.prtrName !== '')
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(props.prtrName), 1)
        ]))
      : _createCommentVNode("", true),
    (props.classificationCode === '7' || (props.ishlName !== null && props.ishlName !== ''))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(props.ishlName), 1)
        ]))
      : _createCommentVNode("", true),
    (
        props.classificationCode === '1' ||
        props.classificationCode === '4' ||
        props.classificationCode === '8'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [
          _createElementVNode("label", {
            class: "low-none flex items-center justify-center",
            style: {"background-color":"rgba(210, 210, 210, 0.8)","font-size":"14px","line-height":"1.5","border-radius":"0","font-weight":"bold","letter-spacing":"1px","padding":"4px 0","width":"100%"}
          }, "取り扱いは中止になりました。", -1)
        ])))
      : _createCommentVNode("", true),
    (props.classificationCode === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[1] || (_cache[1] = [
          _createElementVNode("label", { class: "low-none" }, "-", -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})